import ToolTip from "./ToolTip.svelte";

export const tooltip = (element, params) => {
    let active = false;
    let title;
    let toolTipComponent;

    const mouseEnter = (event) => {
        title = element.getAttribute("title");
        if (!title) return;
        
        active = true;
        element.removeAttribute("title");

        toolTipComponent = new ToolTip({
            props: {
                title: title,
                x: event.pageX,
                y: event.pageY
            },
            target: document.body
        });
    }

    const mouseMove = (event) => {
        active && toolTipComponent.$set({
            x: event.pageX,
            y: event.pageY
        });
    }

    const mouseLeave = () => {
        active && toolTipComponent.$destroy();
        element.setAttribute("title", title);
        active = false;
    }

    element.addEventListener('mouseenter', mouseEnter);
    element.addEventListener('mousemove', mouseMove);
    element.addEventListener('mouseleave', mouseLeave);

    return {
        destroy() {
            element.removeEventListener('mouseenter', mouseEnter);
            element.removeEventListener('mousemove', mouseMove);
            element.removeEventListener('mouseleave', mouseLeave);
        }
    }
}
